<template>
    <div class="LeftMenu">
        <el-menu 
            router
            :default-active="activeIndex"
            class="el-menu-vertical-demo" 
            @select="handleSelect">
            <!-- <el-menu-item index="/market" disabled>
                <i class="el-icon-menu"></i>
                <span slot="title">市场需求</span>
            </el-menu-item> -->
            <el-menu-item index="/searchPage">
                <i class="el-icon-menu"></i>
                <span slot="title">搜索推广</span>
            </el-menu-item>
            <el-menu-item index="/infoPage">
                <i class="el-icon-menu"></i>
                <span slot="title">信息流</span>
            </el-menu-item>
        </el-menu>
    </div>
</template>
<script>
export default {
    name: 'LeftMenu',
    props: {
    },
    data() {
        return {
            activeIndex:'/searchPage'
        };
    },
    methods: {
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
        }
    }
}
</script>

<style scoped lang="less">
.LeftMenu {
    width: 220px;
    /deep/ .el-menu-item {
        padding-left: 50px !important;
    }
}
</style>
